import _ from 'lodash';
import axios from 'axios';

const AC_BASE_URL = 'https://nutritionalfreedom.api-us1.com/api/3';

/* @ts-ignore */
axios.defaults.headers['api-token'] = '9408501c7ac5419155e9d7c2162567832b86fd115f0a950d517d1880be5eb7419b0cb843';
axios.defaults.headers.post['content-type'] = 'application/json';

const useActiveCampaign = () => {
  const tagContact = async (contact: any, tag: any) => {
    if (!tag || !contact) return false;
    const req = await axios.post(
      AC_BASE_URL + '/contactTags',
      JSON.stringify({
        contactTag: {
          contact,
          tag,
        },
      })
    );

    return _.get(req, ['data', 'tag']);
  };

  const findContactByEmail = async (email: string) => {
    const req = await axios.get(AC_BASE_URL + '/contacts', {
      params: { search: email },
    });
    return _.get(req, ['data', 'contacts', 0]);
  };

  const addACContact = async (contact: { firstName: string; lastName: string; email: string; phone: string }) => {
    //add the
    const { firstName, lastName, email, phone } = contact;

    const req = await axios.post(
      AC_BASE_URL + '/contacts',
      JSON.stringify({
        contact: {
          firstName,
          lastName,
          email,
          phone,
        },
      })
    );

    return _.get(req, ['data', 'contact']);
  };

  const upsertTag = async ({ user, tag }: { user: any; tag: any }) => {
    try {
      if (typeof tag !== 'string') tag = tag.toString();
      const tags = tag.split(',');
      const promises = await Promise.all(
        tags.map(async (item: any) => {
          let contactInfo;
          //first see if the contact already exists
          contactInfo = await findContactByEmail(user?.email);

          //if not then add them as a contact
          if (!contactInfo) {
            //add the contact
            contactInfo = await addACContact({
              email: user?.email,
              firstName: user?.firstName,
              lastName: user?.lastName,
              phone: user?.phone.replace('+1', ''),
            });
          }

          if (_.has(contactInfo, 'id')) {
            //after that return the user..then tage them
            const taggedUser = await tagContact(_.get(contactInfo, 'id'), item);

            return taggedUser;
          }
        })
      );

      return await promises;
    } catch (error) {
      console.log(error);
    }
  };

  return { tagContact, findContactByEmail, addACContact, upsertTag };
};

export default useActiveCampaign;
